import AmountModal from './AmountModal';

export default AmountModal;
